module.exports = __webpack_public_path__ + "Gamitronics-d3bb8a73.webp";